import React, { useEffect, useState } from "react";
import "../../App.css";
import "../../profile.css";

import { MapPin, Star } from "lucide-react";

import service from "../../services/service";
import endpoints from "../../services/endpoints";
import { useNavigate } from "react-router-dom";

const Favourite = () => {
  const [favourites, setFavourites] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  /* =========================
      GET FAVOURITES
  ========================= */

  const getFavouriteChallenges = async () => {
    try {
      setLoading(true);

      const response = await service.get(
        endpoints.challenges.favouriteChallenge,
      );

      setFavourites(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFavouriteChallenges();
  }, []);

  return (
    <div className="favourites-page">
      <h1 className="favourites-title">Favourites</h1>

      {loading ? (
        <p className="favourites-loading">Loading favourite challenges...</p>
      ) : favourites?.length > 0 ? (
        <div className="favourites-grid">
          {favourites.map((item) => {
            const challenge = item?.challenge;

            return (
              <div
                className="favourite-card"
                key={item?.id}
                onClick={() => navigate(`/challenges/view/${challenge?.id}`)}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={challenge?.thumbnailImage}
                  alt={challenge?.challengesName}
                  loading="lazy"
                />

                <button className="favourite-btn">
                  <Star size={16} fill="#ff0000" color="#ff0000" />
                </button>

                <div className="favourite-card-content">
                  <h3>{challenge?.challengesName}</h3>

                  <p>
                    <MapPin size={14} />
                    {challenge?.distanceKm} KM
                  </p>
                  
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="favourites-loading">No favourite challenges found</p>
      )}
    </div>
  );
};

export default Favourite;
